import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { KmContextItem } from '@/entities/expert-report-km';
import { NestedItemCard } from '@/features/nested-items';
import { KmContextAttributeTitle } from './KmContextAttributeTitle';
import { useFormatKmContextSources } from './useFormatKmContextSources';

type KmInheritedContextListProps = {
  items: KmContextItem[];
};

const renderItemTitle = (item: KmContextItem) => (
  <KmContextAttributeTitle name={item.attributeName} code={item.attributeCode} />
);

/** Контекст оценки, пришедший к уровню сверху: только для чтения, с уровнями, откуда пришёл каждый атрибут */
export const KmInheritedContextList: FC<KmInheritedContextListProps> = ({ items }) => {
  const { t } = useTranslation('expertReport');
  const formatSources = useFormatKmContextSources();

  const renderItemSources = (item: KmContextItem) => t('km.contextSources', { sources: formatSources(item.sources) });

  return (
    <div className="flex flex-col gap-4">
      <p className="font-medium">{t('km.inheritedContext')}</p>
      <div className="flex flex-col gap-3">
        {items.map((item) => (
          <NestedItemCard
            key={item.attributeCode}
            item={item}
            renderTitle={renderItemTitle}
            renderDescription={renderItemSources}
          />
        ))}
        {items.length === 0 && <p className="text-sm text-muted-foreground">{t('km.noInheritedContext')}</p>}
      </div>
    </div>
  );
};
